package pl.decks.personal.components.widgets.mode

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.style.toModifier

@Composable
internal fun ModeInput(
    options: List<ModeInputOption>,
    modifier: Modifier = Modifier,
) = Row(ModeInputStylesheet.Input.toModifier().then(modifier)) {
    options.forEach { option ->
        Box(
            ModeInputStylesheet.Option.toModifier()
                .weight(1f)
                .onClick { option.onModeClicked() }
                .cursor(Cursor.Pointer)
                .then(option.modifier),
            contentAlignment = Alignment.Center,
        ) { option.content() }
    }
}
